import { Tag, TagProps } from '@chakra-ui/react';
import { ReactElement } from 'react';
export type ToastProps = TagProps;

const Toast = (props: ToastProps): ReactElement | null => (
  <Tag
    as="div"
    mb={2}
    py={1.5}
    px={2}
    fontSize="sm"
    boxShadow="xl"
    bg="white"
    textAlign={'center'}
    opacity=".88"
    {...props}
  />
);

export default Toast;
